/* eslint-disable */
const USER_MANAGE={
    USER_MANAGE_DEACTIVATE:'user/manage/deActivate'
    ,
    USER_MANAGE_ACTIVATE:'user/manage/activate'
    ,
    USER_MANAGE_UNBLOCK:'user/manage/unBlock'
    ,
    USER_MANAGE_BLOCK:'user/manage/block'
    ,
    USER_MANAGE_DELETE:'user/manage/delete'
    ,
    USER_MANAGE_LIST_DRIVER:'user/manage/list/driver'
    ,
    USER_MANAGE_LIST_OPERATOR:'user/manage/list/operator'
    ,
    USER_MANAGE_ADD_USER:'user/manage/add/user'
    ,
    USER_MANAGE_EDIT_PASSWORD:'user/manage/edit/password'
    ,
    USER_MANAGE_LIST_ROLE:'user/manage/list/role'
    ,
    USER_MANAGE_EDIT_ROLE:'user/manage/edit/role'
    ,
    USER_MANAGE_EDIT_DRIVER_CAR:'user/manage/edit/driver/car'
    ,
    USER_MANAGE_EDIT_INFO:'user/manage/edit/info'
    ,
    USER_MANAGE_GET_USER:'user/manage/get/user'
    ,
    USER_MANAGE_LIST_TMS_SECTION : 'user/manage/list/tms/section'
    ,
    USER_MANAGE_EDIT_TMS_SECTION : 'user/manage/edit/tms/section'
    ,
    USER_MANAGE_BASE_STATEREASON_DISABLE:'user/manage/base/stateReason/disable'
    ,
    USER_MANAGE_BASE_STATEREASON_ENABLE:'user/manage/base/stateReason/enable'
    ,
    USER_MANAGE_BASE_STATEREASON_DELETE:'user/manage/base/stateReason/delete'
    ,
    USER_MANAGE_BASE_STATEREASON_EDIT:'user/manage/base/stateReason/edit'
    ,
    USER_MANAGE_BASE_STATEREASON_ADD:'user/manage/base/stateReason/add'
    ,
    USER_MANAGE_BASE_STATEREASON_REPORT:'user/manage/base/stateReason/report'
    ,
    USER_MANAGE_PAYMENT_TRANSACTION_REPORT_UPLOAD:'user/manage/payment/transaction/report/upload'
    ,
    USER_MANAGE_PAYMENT_TRANSACTION_REPORT_CHECK:'user/manage/payment/transaction/report/check',
    USER_MANAGE_DRIVER_OIL_SUPPORT: 'user/manage/driver/oilSupport',
    USER_MANAGE_DRIVER_OIL_UNSUPPORT: 'user/manage/driver/oilUnSupport',


}
export default USER_MANAGE;
